// Safe label capitalizer for Admin Meal List chips.
// Returns '' for null/undefined/empty so a meal missing meal_type/status
// renders nothing instead of the literal string 'NaN' — which is what
// `undefined?.charAt(0).toUpperCase() + undefined?.slice(1)` used to evaluate to.
export const cap = (s) =>
  (typeof s === 'string' && s.length > 0)
    ? s.charAt(0).toUpperCase() + s.slice(1)
    : '';
